import { useNavigate } from 'react-router-dom';

/**
 * Custom hook for safe navigation in both HTTP and HTTPS environments
 * This prevents "insecure operation" errors in React Router
 */
export const useSafeNavigate = () => {
  const navigate = useNavigate();
  
  // Return a wrapped version of navigate that catches security errors
  return (to, options) => {
    try {
      navigate(to, options);
    } catch (error) {
      console.warn('Navigation error suppressed:', error);
      // Fall back to direct URL change if navigation fails
      window.location.href = to.startsWith('/') 
        ? `${window.location.origin}${to}`
        : to;
    }
  };
};

/**
 * Helper function for safe redirection
 * This can be used directly in components without hooks
 */
export const safeRedirect = (to) => {
  try {
    window.location.href = to.startsWith('/') 
      ? `${window.location.origin}${to}`
      : to;
  } catch (error) {
    console.warn('Navigation error suppressed:', error);
    // Even more direct fallback
    window.location.assign(to);
  }
}; 